import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "children"];
import { useContext } from 'react';
import { ButtonWrapper } from '../ButtonWrapper/ButtonWrapper';
import styled from 'foundations-theming/utils';
import { DialogContext } from '../Dialog/DialogContext';
import { PanelContext } from '../../context/PanelContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useWizardFooterContext } from '../Wizard/WizardFooterProvider';
import { StyledButton, StyledButtonTextContainer } from '../Button/PrivateButton';
import { BREAKPOINTS } from '../Grid/Grid.types';
import { deepMerge } from '../../utils/deepMerge/deepMerge';
import { rgba } from '../../utils/color';

//TODO Color token does not exist: PANTERA
import { jsx as _jsx } from "react/jsx-runtime";
const LIGHTBOX_BG_COLOR = '#2d3e50';
const ALIGNMENT_OPTIONS = {
  between: 'between',
  left: 'start',
  center: 'center',
  right: 'end'
};
export const StyledFooter = styled.footer.withConfig({
  displayName: "DialogFooter__StyledFooter",
  componentId: "z6yv5d-0"
})(({
  $align,
  theme: _theme,
  $cssStyles,
  $styleOverrides
}) => {
  const theme = _theme;
  const isConversational = useContext(DialogContext).use === 'conversational';
  const isFullscreen = useContext(DialogContext).use === 'fullscreen';
  const isSidebar = useContext(DialogContext).use === 'sidebar';
  const isPanel = useContext(PanelContext).inPanel;
  const isLightbox = useContext(DialogContext).use === 'lightbox';
  return deepMerge(Object.assign({
    flexGrow: 0,
    flexShrink: 0,
    color: isLightbox ? 'inherit' : undefined,
    backgroundColor: isPanel ? theme.color['fill-surface-raised'] : isLightbox ? `${rgba(LIGHTBOX_BG_COLOR, 0.89)}` : theme.color['fill-surface-default'],
    justifyContent: $align === 'between' ? 'space-between' : $align,
    alignItems: 'center',
    paddingInline: isLightbox ? theme.space['1400'] : theme.space['1000'],
    paddingBlock: theme.space['600'],
    paddingBlockStart: isConversational ? theme.space['0'] : undefined,
    borderEndStartRadius: isSidebar ? theme.borderRadius['0'] : !isFullscreen ? theme.borderRadius['100'] : undefined,
    borderEndEndRadius: isSidebar ? theme.borderRadius['0'] : !isFullscreen ? theme.borderRadius['100'] : undefined,
    zIndex: isPanel ? 1 : undefined,
    borderBlockStart: isPanel ? `${theme.borderWidth['100']} solid ${theme.color['border-core-default']}` : undefined,
    textAlign: 'left',
    [`& ${StyledButton} ${StyledButtonTextContainer} span`]: {
      [`@media only screen and (max-width: ${BREAKPOINTS.sm}px)`]: {
        width: '100%',
        textAlign: 'center'
      }
    }
  }, $cssStyles, {
    [`> * + *`]: {
      [`@media only screen and (min-width: rem-calc(map-get($grid-breakpoints, sm) + 1))`]: {
        marginInlineStart: theme.space['300']
      }
    }
  }), $styleOverrides);
});
export function DialogFooter(_ref) {
  var _wizardFooterContext$;
  let {
      align = 'left',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const wizardFooterContext = useWizardFooterContext();
  return /*#__PURE__*/_jsx(StyledFooter, Object.assign({}, domProps, {
    $align: align,
    $cssStyles: cssStyles,
    $styleOverrides: (_wizardFooterContext$ = wizardFooterContext === null || wizardFooterContext === void 0 ? void 0 : wizardFooterContext.footerStyleOverrides) !== null && _wizardFooterContext$ !== void 0 ? _wizardFooterContext$ : {},
    children: /*#__PURE__*/_jsx(ButtonWrapper, {
      justify: ALIGNMENT_OPTIONS[align],
      children: children
    })
  }));
}